import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'shared-confirm',
    imports: [MatDialogModule, MatButtonModule, MatIconModule, CommonModule],
    template: `
        <h2 mat-dialog-title class="confirm-title">
            {{ config.title }}
            <button class="close-button" mat-icon-button mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </h2>
        <mat-dialog-content class="confirm-content">
            <div class="description" [innerHTML]="formattedDescription"></div>
        </mat-dialog-content>
        <mat-dialog-actions align="end" class="confirm-actions">
            <button mat-stroked-button mat-dialog-close class="cancel-btn">Cancel</button>
            <button mat-flat-button color="primary" [mat-dialog-close]="config.confirmResultData" class="confirm-btn">
                Confirm
            </button>
        </mat-dialog-actions>
    `,
    styles: [
        `
            :host {
                display: block;
            }

            .confirm-title {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin: 0;
                padding: 16px 24px;
                font-size: 1.25rem;
                font-weight: 500;
                border-bottom: 1px solid rgba(0, 0, 0, 0.12);
            }

            :host-context(.dark-theme) .confirm-title {
                border-bottom-color: rgba(255, 255, 255, 0.1);
            }

            .close-button {
                margin-right: -8px;
            }

            .confirm-content {
                min-width: min(400px, 70vw);
                max-width: 500px;
                padding: 24px !important;
                box-sizing: border-box;
            }

            .description {
                font-size: 0.95rem;
                line-height: 1.6;
                color: rgba(0, 0, 0, 0.87);
                white-space: pre-wrap;
            }

            :host-context(.dark-theme) .description {
                color: rgba(255, 255, 255, 0.85);
            }

            .description ::ng-deep p {
                margin: 0 0 12px 0;
            }

            .description ::ng-deep p:last-child {
                margin-bottom: 0;
            }

            .confirm-actions {
                padding: 16px 24px !important;
                border-top: 1px solid rgba(0, 0, 0, 0.12);
                gap: 12px;
            }

            :host-context(.dark-theme) .confirm-actions {
                border-top-color: rgba(255, 255, 255, 0.1);
            }

            .cancel-btn {
                min-width: 100px;
            }

            .confirm-btn {
                min-width: 100px;
            }
        `,
    ],
})
// eslint-disable-next-line @angular-eslint/component-class-suffix -- public API: exported from the barrel and imported by class name (MatDialog.open(ConfirmDialog, ...)) from newgenus-frontend and e2e; renaming would break every consumer
export class ConfirmDialog {
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public config: {
            title: string;
            description: string;
            confirmResultData: any;
        }
    ) {}

    /**
     * Format the description to handle newlines and bullet points
     */
    get formattedDescription(): string {
        if (!this.config.description) return '';

        // Convert newlines to <br> and wrap in paragraphs
        return this.config.description
            .split('\n\n')
            .map((paragraph) => `<p>${paragraph.replace(/\n/g, '<br>')}</p>`)
            .join('');
    }
}
